import { render, staticRenderFns } from "./ExerciseCatalogCard.vue?vue&type=template&id=5deb5744&scoped=true&"
import script from "./ExerciseCatalogCard.vue?vue&type=script&lang=js&"
export * from "./ExerciseCatalogCard.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseCatalogCard.vue?vue&type=style&index=0&id=5deb5744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb5744",
  null
  
)

export default component.exports